import React, { useCallback, useMemo, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import FormBuilder from "../formBuilder/FormBuilder";
import { PaperComponent } from "..";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  hiddenLabel: {
    opacity: 0,
    height: 0,
    pointerEvents: "none",
  },
  notchedOutline: {
    borderTopWidth: 1,
  },
}));

const parseJsonValue = (value) => {
  if (value === undefined || value === null || value === "") return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const ensureSubmitTrue = (payload) => {
  if (!payload || typeof payload !== "object") {
    return { formProps: { submit: "true" }, fields: [] };
  }
  const rawFormProps = payload.formProps && typeof payload.formProps === "object" ? payload.formProps : {};
  const next = { ...payload, formProps: { ...rawFormProps, submit: "true" } };
  if (next.props) delete next.props;
  return next;
};

export const FormBuilderOqt = ({
  name,
  caption,
  formik,
  value,
  details = false,
  variant = "outlined",
  size = "medium",
  disabled = false,
  onChange,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const rawValue = formik ? formik.values[name] : value;
  const parsedValue = useMemo(() => parseJsonValue(rawValue), [rawValue]);
  const hasParseError = Boolean(rawValue) && typeof rawValue === "string" && parsedValue === null;

  const builderValue = useMemo(() => {
    const base = !parsedValue ? { fields: [] } : Array.isArray(parsedValue) ? { fields: parsedValue } : parsedValue;
    return ensureSubmitTrue(base);
  }, [parsedValue]);

  const fieldCount = useMemo(() => {
    if (!builderValue || !Array.isArray(builderValue.fields)) return 0;
    return builderValue.fields.length;
  }, [builderValue]);

  const handleOpen = useCallback(() => {
    if (details || disabled) return;
    setOpen(true);
  }, [details, disabled]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleBuilderChange = useCallback(
    (payload) => {
      const nextPayload = ensureSubmitTrue(payload);
      const nextValue = JSON.stringify(nextPayload);
      if (formik) {
        if (formik.values[name] !== nextValue) {
          formik.setFieldValue(name, nextValue);
        }
      } else if (onChange) {
        onChange({ target: { name, value: nextValue } });
      }
    },
    [formik, name, onChange]
  );

  if (details) {
    return (
      <div style={{ padding: 8, width: "100%" }}>
        <Typography variant="body2" color="textSecondary">
          {caption}
        </Typography>
        <Typography variant="body1">
          {hasParseError ? "JSON inválido" : `${fieldCount} campo${fieldCount === 1 ? "" : "s"}`}
        </Typography>
      </div>
    );
  }

  return (
    <div style={{ padding: 8, width: "100%" }}>
      <FormControl fullWidth variant={variant} size={size} error={hasParseError}>
        <InputLabel
          shrink={false}
          htmlFor={`${name}-formbuilder`}
          className={classes.hiddenLabel}
        >
          Formulario
        </InputLabel>
        <OutlinedInput
          id={`${name}-formbuilder`}
          readOnly
          value="Formulario"
          label="Formulario"
          classes={{ notchedOutline: classes.notchedOutline }}
          endAdornment={
            <InputAdornment position="end">
              <Button onClick={handleOpen} disabled={disabled} variant="outlined" size="small">
                Diseño
              </Button>
            </InputAdornment>
          }
        />
      </FormControl>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        PaperComponent={PaperComponent}
        PaperProps={{ style: { height: "84vh", display: "flex", flexDirection: "column" } }}
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {caption || "Diseño"}
        </DialogTitle>
        <DialogContent style={{ padding: 0, flex: 1, overflow: "hidden" }}>
          <div style={{ height: "100%" }}>
            <FormBuilder
              value={builderValue}
              onChange={handleBuilderChange}
              hideHeader={true}
              hideToolbar={true}
              embedded={true}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
